import { createContext } from 'react';

const widgetContext = createContext();

export default widgetContext;